import {React, useState, useEffect} from 'react';
import "./ProjectsPage.css";
import Project from '../Projects';

import ShoobStreamsPreview from '../../assets/project-previews/ShoobStreamsPreview.png';
import ShoobTubePreview from '../../assets/project-previews/ShoobTubePreview.png';
import ShoogleImagesPreview from '../../assets/project-previews/ShoogleImagesPreview.png';
import FitPicPreview from '../../assets/project-previews/FitPicPreview.png';
import FamilyFeudPreview from '../../assets/project-previews/FamilyFeudPreview.png'
import LyricLoverPreview from '../../assets/project-previews/LyricLoverPreview.png'
import ApplicationAssistantPreview from '../../assets/project-previews/ApplicationAssistantPreview.png'
import ByteMapPreview from '../../assets/project-previews/ByteMapPreview.png'
import DoodleJumpPreview from '../../assets/project-previews/DoodleJumpPreview.png'
import MatiPreview from '../../assets/project-previews/MatiPreview.png'
import BetulaPreview from '../../assets/project-previews/BetulaPreview.png'
import HurriScanPreview from '../../assets/project-previews/HurriScanPreview.png'
import PillPartnerPreview from '../../assets/project-previews/PillPartnerPreview.png'
import DJPreview from '../../assets/project-previews/DJPreview.png';
import SousPreview from '../../assets/project-previews/SousPreview.jpg';
import SPInterfacePreview from '../../assets/project-previews/SPInterfacePreview.jpg';
import PillPartnerV2Preview from '../../assets/project-previews/PillPartnerV2Preview.png'

const PROJECT_TYPES = {
    App: "Apps",
    Embedded: 'Embedded Systems',
    Web: "Web Apps",
    AI: "CV & AI",
    Misc: "Miscellaneous / CLI"

};

const projects = [
    {
        title: "Sous",
        desc: "A gesture controlled recipe reader application",
        git: "https://github.com/seanpourgoutzidis/Sous",
        demo: "https://www.youtube.com/watch?v=KjYgKfUZ7S4",
        preview: SousPreview,
        language: "Python/Flask",
        type: PROJECT_TYPES.App
    },
    {
        title: "SPInterface",
        desc: "An application that allows you to control your Mac via gestures",
        git: "https://github.com/seanpourgoutzidis/SPInterface",
        demo: "https://youtu.be/jx4TeRAwqYA",
        preview: SPInterfacePreview,
        language: "Python",
        type: PROJECT_TYPES.AI,
    },
    {
        title: "Pill Partner",
        desc: "Microcontroller-based automatic pill dispenser to help elderly take their medication on time. Developed in a team of 2 at UofT",
        git: "https://github.com/charlottepfritz/PillPartner",
        demo: "https://drive.google.com/file/d/1OWs3rnpRt7eQpyV80M1d5LYWfoVwCZGb/view?usp=drive_link",
        preview: PillPartnerPreview,
        language: "C",
        type: PROJECT_TYPES.Embedded
    },
    {
        title: "HurriScan",
        desc: "PyTorch Deep Learning Model for Hurricane Intensity Prediction developed in a team of 4",
        git: "https://github.com/macaroonforu/HurriScan",
        demo: "https://drive.google.com/file/d/19rEmTvcj-dvJqhJ7uodOpZdjCWpxrR81/view?usp=drive_link",
        preview: HurriScanPreview,
        language: "Python/PyTorch",
        type: PROJECT_TYPES.AI
    },
    {
        title: "Betula",
        desc: "A UofT Event Finder App Developed for Software Engineering Course in a team of 7",
        git: "https://github.com/ECE444-2023Fall/project-1-web-application-design-group19-webcrafters",
        demo: "https://drive.google.com/file/d/1pp0vr91XpNafrVqG309sCjXfcplWmJHs/view?usp=sharingLinks to an external site.",
        preview: BetulaPreview,
        language: "Python/Flask",
        type: PROJECT_TYPES.Web

    },
    {
        title: "ApplicationAssistant",
        desc: "An automatic application tracker that cross-references a spreadsheet with your email inbox",
        git: "https://github.com/seanpourgoutzidis/ApplicationAssistant",
        demo: "https://www.youtube.com/watch?v=MTVr7DEyxlI",
        preview: ApplicationAssistantPreview,
        language: "Python",
        type: PROJECT_TYPES.Misc
    },
    {
        title: "PillPartnerV2",
        desc: "An embedded systems project to monitor if my grandparents are taking their medications on time",
        git: "https://github.com/seanpourgoutzidis/PillPartnerV2/",
        demo: "https://youtu.be/PeERiaaR3v0",
        preview: PillPartnerV2Preview,
        language: "C++",
        type: PROJECT_TYPES.Embedded,
    },
    {
        title: "ByteMap",
        desc: "A GIS application coded with C++ for ECE297 at UofT in a team of 3",
        git: "https://github.com/seanpourgoutzidis/ByteMap",
        demo: "https://youtu.be/QZlZSaMNL7M",
        preview: ByteMapPreview,
        language: "C++",
        type: PROJECT_TYPES.App
    },
    {
        title: "Mati",
        desc: "Computer vision and LLM powered guide robot made with Yolov5 & HuggingFace as a proof of concept",
        git: "https://github.com/seanpourgoutzidis/Mati",
        demo: "https://www.youtube.com/watch?v=HxpIs5khI1I",
        preview: MatiPreview,
        language: "Python",
        type: PROJECT_TYPES.AI

    },
    {
        title: "DoodleJump",
        desc: "C implementation of Doodle Jump on the DE1-SoC board for ECE243 at UofT",
        git: "https://github.com/hallovera/doodlejump",
        demo: "https://youtu.be/VT6EUjjL9EQ",
        preview: DoodleJumpPreview,
        language: "C",
        type: PROJECT_TYPES.Embedded
    },
    {
        title: "DJ",
        desc: "Python script that allows you to control playback on your Music app on your Mac with gestures",
        git: "https://github.com/seanpourgoutzidis/DJ/",
        demo: "https://youtube.com/shorts/WAbr3m6NOE8?feature=share",
        preview: DJPreview,
        language: "Python",
        type: PROJECT_TYPES.AI,
    },
    {
        title: "LyricLover",
        desc: "An app that utilizes the Genius API to download and email lyrics for any song/album",
        git: "https://github.com/seanpourgoutzidis/LyricLover",
        demo: "https://youtu.be/MbhYmHgUyok",
        preview: LyricLoverPreview,
        language: "Python",
        type: PROJECT_TYPES.Misc
    },
    {
        title: "Family Feud",
        desc: "An application that simulates the popular game-show family feud!",
        git: "https://github.com/seanpourgoutzidis/FamilyFeud",
        demo: "https://replit.com/@SeanPourgout/FamilyFeud#Main.java",
        preview: FamilyFeudPreview,
        language: "Java",
        type: PROJECT_TYPES.Misc
    },
    {
        title: "FitPic",
        desc: "An outfit randomizer I designed to help choose your outfit on those days you just can’t decide!",
        git: "https://github.com/seanpourgoutzidis/FitPic",
        demo: "https://replit.com/@SeanPourgout/FitPic#main.c",
        preview: FitPicPreview,
        language: "C",
        type: PROJECT_TYPES.Misc
    },

    {
        title: "ShoobStream",
        desc: "This site is a low-fidelity clone of Twitch using APIs and redux stores.",
        git: 'https://github.com/seanpourgoutzidis/ShoobStreams',
        demo: 'https://youtu.be/9moxEsUg-Hs',
        preview: ShoobStreamsPreview,
        language: "React JS",
        type: PROJECT_TYPES.Web

    },
    {
        title: "ShoobTube",
        desc: "This site is a low-fidelity clone of YouTube using APIs",
        git: "https://github.com/seanpourgoutzidis/ShoobTube",
        demo: "https://youtu.be/uQCZ_Wl7D40",
        preview: ShoobTubePreview,
        language: "React JS",
        type: PROJECT_TYPES.Web
    },
    {        
        title: "Shoogle Images",
        desc: "This site is a low-fidelity clone of Google Images using APIs",
        git: "https://github.com/seanpourgoutzidis/ShoogleImages",
        demo: "https://6309103510e1a3007779f0f5--monumental-starlight-b3d653.netlify.app/",
        preview: ShoogleImagesPreview,
        language: "React JS",
        type: PROJECT_TYPES.Web
    },
];


const ProjectsPage = () => {

    const [filter, setFilter] = useState('All Projects');
    const [showAll, setShowAll] = useState(false);
    const [projectsToRender, setProjectsToRender] = useState([]);
    const [projectList, setProjectList] = useState([]);

    useEffect(() => {
        const filteredProjects = projects.filter((project) => {
            if (filter === 'All Projects') {
                return true
            }
            return project.type === filter;
        });
        setProjectList(filteredProjects);
    }, [filter]);

    useEffect(() => {
        const numProjectsToRender = showAll ? (projectList.length - 1) : 4;
        const finalList = projectList.slice(0, numProjectsToRender);
        setProjectsToRender(finalList)
    }, [projectList, showAll])

    function filterSet(event) {
        setFilter(event.target.value);
    }

    function toggleShowAll() {
        setShowAll(!showAll);
    }

    function renderShowAllButton() {
        if (projectList.length <= 4) {
            return
        }
        
        return (<button onClick={toggleShowAll}>{showAll ? 'Show Less' : 'Show All'}</button>);
    }
    

    return (
        <article id="ProjectsPage" className="projects">
            <header>
                <h2>Projects</h2>
                <select name="project-type" id="project-type" value={filter} onChange={e => filterSet(e)}>
                    <option>All Projects</option>
                    <option>Apps</option>
                    <option>Embedded Systems</option>
                    <option>Web Apps</option>
                    <option>CV & AI</option>
                    <option>Miscellaneous / CLI</option>
                </select>
            </header>
            <section>
                <Project projects={ projectsToRender } />
            </section>
            { renderShowAllButton() }
        </article>
    );
}

export default ProjectsPage;